import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Group>>>;

const getIndividualGroups = (individualUuid: string): ReturnType => {
    return Request.get(`/individuals/${individualUuid}/groups`);
};

export default getIndividualGroups;
